import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const LockIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" boxSize={4} fill="none" {...props}>
    <g id="Icon / lock">
      <mask
        id="mask0_15171_5320"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect id="Bounding box" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_15171_5320)">
        <path
          id="Vector"
          d="M3.99996 14.6665C3.63329 14.6665 3.3194 14.5359 3.05829 14.2748C2.79718 14.0137 2.66663 13.6998 2.66663 13.3332V6.6665C2.66663 6.29984 2.79718 5.98595 3.05829 5.72484C3.3194 5.46373 3.63329 5.33317 3.99996 5.33317H4.66663V3.99984C4.66663 3.07762 4.99163 2.2915 5.64163 1.6415C6.29163 0.991504 7.07774 0.666504 7.99996 0.666504C8.92218 0.666504 9.70829 0.991504 10.3583 1.6415C11.0083 2.2915 11.3333 3.07762 11.3333 3.99984V5.33317H12C12.3666 5.33317 12.6805 5.46373 12.9416 5.72484C13.2027 5.98595 13.3333 6.29984 13.3333 6.6665V13.3332C13.3333 13.6998 13.2027 14.0137 12.9416 14.2748C12.6805 14.5359 12.3666 14.6665 12 14.6665H3.99996ZM7.99996 11.3332C8.36663 11.3332 8.68051 11.2026 8.94163 10.9415C9.20274 10.6804 9.33329 10.3665 9.33329 9.99984C9.33329 9.63317 9.20274 9.31928 8.94163 9.05817C8.68051 8.79706 8.36663 8.6665 7.99996 8.6665C7.63329 8.6665 7.3194 8.79706 7.05829 9.05817C6.79718 9.31928 6.66663 9.63317 6.66663 9.99984C6.66663 10.3665 6.79718 10.6804 7.05829 10.9415C7.3194 11.2026 7.63329 11.3332 7.99996 11.3332ZM5.99996 5.33317H9.99996V3.99984C9.99996 3.44428 9.80551 2.97206 9.41663 2.58317C9.02774 2.19428 8.55551 1.99984 7.99996 1.99984C7.4444 1.99984 6.97218 2.19428 6.58329 2.58317C6.1944 2.97206 5.99996 3.44428 5.99996 3.99984V5.33317Z"
          fill="#6B767B"
        />
      </g>
    </g>
  </Icon>
);

export default LockIcon;
